import * as ApiRequests from '../../api/requests';
import { AuthHelper } from '../../types/auth-helper-types';
import { UserSettingsActions } from '../actions/user-settings-actions';
import { AppThunk } from '../actions';
import { SiteRole } from '../../types';

export const UserSettingsThunks = {
    userSettingsProviderMounted: (userId: string, authHelper: AuthHelper): AppThunk => async (
        dispatch
    ): Promise<void> => {
        dispatch(UserSettingsActions.loadUserSettingsStarted());

        const payload = await ApiRequests.getUserSettings({ userId }, { authHelper });

        if (payload.ok) {
            dispatch(
                UserSettingsActions.loadUserSettingsSucceeded(payload.httpStatusCode, {
                    ...payload.response.data,
                    user: {
                        ...payload.response.data.user,
                        phone: payload.response.data.user.phone || '',
                    },
                })
            );
        } else {
            dispatch(UserSettingsActions.loadUserSettingsFailed());
        }
    },

    updateUserData: (
        notify: boolean,
        sms: boolean,
        session: boolean,
        userId: string,
        authHelper: AuthHelper,
        isEmail: boolean
    ): AppThunk => async (dispatch): Promise<void> => {
        if (isEmail) dispatch(UserSettingsActions.updateEmailUserDataStarted());
        else dispatch(UserSettingsActions.updateSmsUserDataStarted());

        const payload = await ApiRequests.setUserSettings(
            {
                userId,
                notification: { emailenabled: notify, smsenabled: sms },
                session: { sessionEnabled: session },
                language: { id: 1 },
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(UserSettingsActions.updateUserDataSucceeded(notify, sms, session));
            return;
        }
        dispatch(UserSettingsActions.updateUserDataFailed());
    },
    updateUserSessionData: (
        notify: boolean,
        sms: boolean,
        session: boolean,
        userId: string,
        authHelper: AuthHelper
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(UserSettingsActions.updateSessionUserDataStarted());

        const payload = await ApiRequests.setUserSettings(
            {
                userId,
                notification: { emailenabled: notify, smsenabled: sms },
                session: { sessionEnabled: session },
                language: { id: 1 },
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(UserSettingsActions.updateUserDataSucceeded(notify, sms, session));
            return;
        }
        dispatch(UserSettingsActions.updateUserDataFailed());
    },

    userChangePassword: (oldPassword: string, newPassword: string, authHelper: AuthHelper) => async (
        dispatch: Function
    ): Promise<void> => {
        dispatch(UserSettingsActions.changePasswordStarted());
        const payload = await ApiRequests.changePassword(
            {
                currentpassword: oldPassword,
                newpassword: newPassword,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(UserSettingsActions.changePasswordSucceeded());
        } else {
            dispatch(UserSettingsActions.changePasswordFailed());
        }
    },

    updateUserDetails: (
        userId: string,
        fName: string,
        lName: string,
        phoneNo: string,
        countryCode: string,
        email: string,
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        const phoneNumber = `${countryCode}${phoneNo}`;

        dispatch(UserSettingsActions.updateUserDetailsStarted());

        const payload = await ApiRequests.setUserSettings(
            {
                userId,
                user: { fName: fName, lName: lName, phone: phoneNumber },
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(UserSettingsActions.updateUserDetailsSucceeded(fName, lName, phoneNo, email));

            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(UserSettingsActions.updateUserDataFailed());
    },

    updateUserRole: (
        userId: string,
        updatedRoles: SiteRole[],
        authHelper: AuthHelper,
        addToast: Function
    ): AppThunk => async (dispatch): Promise<void> => {
        dispatch(UserSettingsActions.updateUserRoleStarted());

        const payload = await ApiRequests.updateUserRole(
            {
                userId,
                role: updatedRoles,
            },
            { authHelper }
        );

        if (payload.ok) {
            dispatch(UserSettingsActions.updateUserRoleSucceeded(updatedRoles));
            return;
        }
        addToast(`${ApiRequests.extractResponseNotOkMessage(payload.response)}`, 'error');
        dispatch(UserSettingsActions.updateUserRoleFailed());
    },
};
